<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import {userGridData} from "./data-grid";
import Stat from "@/components/widgets/stat";

/**
 * Contacts-Profile component
 */
export default {
  page: {
    title: "Employee report",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      title: "Employee report",
      userGridData: userGridData,
      statData: [
        {
          icon: "bx bx-dizzy",
          title: "Absenteeism (last 6 months)",
          value: "4 days"
        },
        {
          icon: "bx bx-hourglass",
          title: "Overtime (last 6 months)",
          value: "62 hours"
        },
        {
          icon: "bx bx-sun",
          title: "Vacation days left (this year)",
          value: "15 days"
        },
        {
          icon: "bx bx-chevrons-up",
          title: "Last performance evaluation",
          value: "Good"
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">Demie Schols</h5>
                  <p>UI/UX Designer</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-4">
                  <img
                    src="@/assets/images/users/avatar-1.jpg"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                </div>
              </div>

              <div class="col-sm-8">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-5">
                <h5 class="font-size-15">Start date</h5>
                <p class="text-muted mb-0">03-08-2018</p>
                    </div>
                    <div class="col-7">
                      <h5 class="font-size-15">Contract length</h5>
                      <p class="text-muted mb-0">2 years</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-0">
              <router-link to="/users" class="btn btn-primary btn-sm">
                Go to registry
                <i class="bx bx-user ml-1"></i>
              </router-link>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Personal Information</h4>

            <div class="table-responsive mb-2">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">Full Name :</th>
                    <td>Demie Marie Schols</td>
                  </tr>
                  <tr>
                    <th scope="row">Date of birth :</th>
                    <td>02-03-1985 (35)</td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile :</th>
                    <td>(123) 123 1234</td>
                  </tr>
                  <tr>
                    <th scope="row">E-mail :</th>
                    <td>demie@willo.nu</td>
                  </tr>
                  <tr>
                    <th scope="row">Address :</th>
                    <td>Grachtenstraat 120, 1022TT<br />Amsterdam, The Netherlands</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mb-0">
              <a href class="btn btn-primary btn-sm">
                Update information
                <i class="mdi mdi-file-document-edit ml-1"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Current contract information</h4>

            <div class="table-responsive mb-2">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">Starting date :</th>
                    <td>03-08-2018</td>
                  </tr>
                  <tr>
                    <th scope="row">End date :</th>
                    <td>01-08-2020</td>
                  </tr>
                  <tr>
                    <th scope="row">Contract length :</th>
                    <td>2 years</td>
                  </tr>
                  <tr>
                    <th scope="row">Salary (yearly):</th>
                    <td>€68.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mb-0">
              <a href class="btn btn-primary btn-sm">
                View contract
                <i class="mdi mdi-arrow-right ml-1"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">News & links</h4>
            <div class="table-responsive mb-2">
              <ul>
                <li><a href="#">Company policy updates</a></li>
                <li><a href="#">Update week 37</a></li>
                <li><a href="#">HR manual</a></li>
              </ul>
            </div>
            <div class="mb-0">
              <a href class="btn btn-primary btn-sm">
                Go to documents
                <i class="mdi mdi-arrow-right ml-1"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>


      <div class="col-xl-8">
        <div class="row">
          <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Objectives & Key results</h4>
            <div class="table-responsive mb-0">
              <table class="table table-nowrap table-hover">
                <thead>
                  <tr>
                    <th scope="col">Quarter</th>
                    <th scope="col">Objective</th>
                    <th scope="col">Progress</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Q2 2020</td>
                    <td>Reduce turnaround time of designs to less than 6 days.</td>
                    <td>100%</td>
                  </tr>
                  <tr>
                    <td>Q2 2020</td>
                    <td>Reach target of 100 designs.</td>
                    <td>70%</td>
                  </tr>
                  <tr>
                    <td>Q3 2020</td>
                    <td>Write 10 articles on web design.</td>
                    <td>20%</td>
                  </tr>
                  <tr>
                    <td>Q3 2020</td>
                    <td>Teach at least 3 classes on UX design internally.</td>
                    <td>10%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mb-0">
              <a href class="btn btn-primary btn-sm">
                Add OKRs
                <i class="mdi mdi-plus ml-1"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="row">
          <div v-for="user in userGridData" :key="user.id" class="col-sm-3">
              <a target="_blank" :href="user.link" class="text-dark">
                  <div class="card text-center">
                      <div class="card-body">
                          <div class="mb-4">
                              <img class="rounded-circle avatar-xl" :style="{backgroundColor: user.background_color}" :src="`${user.image}`" alt/>
                          </div>
                          <h5 class="font-size-15">
                              {{user.name}}
                          </h5>
                      </div>
                  </div>
              </a>
          </div>
        </div>


      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>